// Module
var code = " <div class=\"\"> Web Components Demo </div> <hello-world name=\"Craig\" color=\"red\">...Loading...</hello-world> <hello-world name=\"Paul\">Hello 2</hello-world>";
// Exports
export default code;